import { render, staticRenderFns } from "./BookingEditForm.vue?vue&type=template&id=174cbb80&"
import script from "./BookingEditForm.vue?vue&type=script&lang=js&"
export * from "./BookingEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports